import type { components } from '@pba/types-openapi-client';
import type { MembershipsCountDataObject } from '../service';

export type Membership = {
  id: string;
  role: MembershipRole;
  subjectId: string;
  subjectType: MembershipSubjectType;
};

export type MembershipRole = 'admin' | 'member' | 'navigator_supervisor' | 'navigator';

export type MembershipsCount = {
  joinedCommunities?: number;
  joinedOrganizations?: number;
  joinedPrograms?: number;
};

export const createMembershipsCount = (data: MembershipsCountDataObject) => ({
  joinedCommunities: data.joined_communities,
  joinedOrganizations: data.joined_organizations,
  joinedPrograms: data.joined_programs,
});

export type MembershipSubjectType = 'Community' | 'Group' | 'Organization' | 'Program';

export const createMembership = (data: components['schemas']['Membership']) => ({
  id: data.id,
  role: data.role,
  subjectId: data.subject_id,
  subjectType: data.subject_type,
});

export type NodeMembership = {
  ref: string;
  role: string;
  type: string;
};
